import { useMemo, useState } from 'react';

export const useLetterCounter = (maxLenght: number) => {
  const [word, setWord] = useState('');
  const [error, setError] = useState(true);

  const remaining = useMemo(() => {
    const length = maxLenght >= word.length ? maxLenght - word.length : 0;
    if (length > 0) setError(false);
    else setError(true);

    return length;
  }, [word, maxLenght]);

  return { remaining, word, setWord, error, maxLenght };
};
